import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function SftpMessageEventFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>Extract an SFTP message event from Notable databases.</FormHelperText>
    </Box>
  );
}
